import PropTypes from 'prop-types';
import React, { useLayoutEffect } from 'react';

import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { CssBaseline, GlobalStyles, ThemeProvider, createTheme } from '@mui/material';
import { prefixer } from 'stylis';
import rtlPlugin from 'stylis-plugin-rtl';

const caches = {
  ltr: createCache({
    key: 'muiltr',
  }),
  rtl: createCache({
    key: 'muirtl',
    stylisPlugins: [prefixer, rtlPlugin],
  }),
};

function Direction(props) {
  const { dir = 'ltr', children } = props;

  useLayoutEffect(() => {
    document.dir = dir;
  }, [dir]);

  return <CacheProvider value={caches[dir]}>{children}</CacheProvider>;
}

Direction.propTypes = {
  children: PropTypes.node.isRequired,
  dir: PropTypes.oneOf(['rtl', 'ltr']),
};

let themeInstance;

function MaterialTheme(props) {
  const { children, theme, forceDir } = props;

  if (!themeInstance) {
    themeInstance = createTheme(theme);
  }

  const newTheme = forceDir ? { ...themeInstance, direction: forceDir } : themeInstance;

  return (
    <Direction dir={newTheme.direction}>
      <ThemeProvider theme={newTheme}>
        <GlobalStyles styles={{ html: { fontSize: 10 } }} />
        <CssBaseline />

        {children}
      </ThemeProvider>
    </Direction>
  );
}

MaterialTheme.propTypes = {
  children: PropTypes.node.isRequired,
  theme: PropTypes.object,
  forceDir: PropTypes.oneOf(['ltr', 'rtl']),
};

export default React.memo(MaterialTheme);
